export enum ProjectAccessAction {
  Migrate = 'migrate',
  EnableShare = 'enableShare',
  DisableShare = 'disableShare',
  Edit = 'edit',
  Rename = 'rename',
  Download = 'download',
  View = 'view',
  Delete = 'delete',
  Move = 'move',
  Reorder = 'reorder',
  Read = 'read',
  Create = 'create',
  Update = 'update',
}

export enum ProjectAccessSubject {
  Project = 'Project',
  Clip = 'Clip',
  ImportScript = 'import_script',
  AudioFiles = 'audio_files',
  Sections = 'sections',
  Takes = 'takes',
}
